import React from 'react';

import '../../css/Home.css';

const DENTAL_PUENTE_LOCATION = {
  lat: 20.616824616560514,
  lng: -103.3751566,
  zoom: 18,
  label: 'Dental Puente',
};

const MapContainer: React.FC = () => {
  const { lat, lng, zoom, label } = DENTAL_PUENTE_LOCATION;
  const delta = 0.0022;

  const bbox = [
    lng - delta,
    lat - delta,
    lng + delta,
    lat + delta,
  ].join('%2C');

  const marker = `${lat}%2C${lng}`;
  const mapSrc = `https://www.openstreetmap.org/export/embed.html?bbox=${bbox}&layer=mapnik&marker=${marker}`;
  const openMapUrl = `https://www.openstreetmap.org/?mlat=${lat}&mlon=${lng}#map=${zoom}/${lat}/${lng}`;

  return (
    <section className="osmMapCard" aria-label={`Mapa de ubicación de ${label}`}>
      <iframe
        className="osmMapFrame"
        title={`Mapa - ${label}`}
        src={mapSrc}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
      <div className="osmMapFooter">
        <span>{label}</span>
        <a href={openMapUrl} target="_blank" rel="noreferrer">
          Abrir mapa
        </a>
      </div>
    </section>
  );
};

export default MapContainer;
